import { MapPin, Calendar, Clock, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { useT } from "@/i18n/LanguageContext";
import { NewsletterSignup } from "./NewsletterSignup";

export const Footer = () => {
  const { t } = useT();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#0a0a0a] text-zinc-400 font-body"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="/brand/ccc-pictorial.svg" alt="CCC" className="h-10 w-auto" />
            <img src="/brand/ccc-lettermark.svg" alt="Cologne Card Con" className="h-8 w-auto" />
          </div>
          <p className="text-sm leading-relaxed max-w-md mb-4">{t("footer.blurb")}</p>
          <NewsletterSignup />
        </div>

        <div>
          <div className="eyebrow mb-3">{t("footer.event")}</div>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2">
              <Calendar size={14} className="text-[#FFCC51]" /> 06.09.2026
            </li>
            <li className="flex items-center gap-2">
              <Clock size={14} className="text-[#FFCC51]" /> 10:00 &ndash; 18:00
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={14} className="text-[#FFCC51] mt-1" />
              <span>
                Halle Tor 2<br />
                Girlitzweg 30, 50829 Köln
              </span>
            </li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-3">{t("footer.contact")}</div>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2">
              <Mail size={14} className="text-[#FFCC51]" /> info@cologne-card-con.de
            </li>
            <li>
              <Link to="/tickets" className="hover:text-white">{t("footer.tickets_link")}</Link>
            </li>
            <li>
              <Link to="/booths" className="hover:text-white">{t("footer.booths_link")}</Link>
            </li>
            <li>
              <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white">{t("footer.admin")}</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 text-xs flex flex-col md:flex-row justify-between gap-3 text-zinc-500">
          <span>{t("footer.copyright")}</span>
          <span className="flex gap-3 flex-wrap">
            <Link to="/impressum" data-testid="footer-impressum" className="hover:text-white">Impressum</Link>
            <span>·</span>
            <Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-white">Datenschutz</Link>
            <span>·</span>
            <Link to="/agb" data-testid="footer-agb" className="hover:text-white">AGB</Link>
          </span>
        </div>
      </div>
    </footer>
  );
};
